export const webview = {
  webviewContent: 'Dit is een externe URL en zal worden geopend in een nieuw venster. Openen?',
  webviewButtonOpenTitle: 'Openen',
  webviewButtonCopyTitle: 'URL kopiëren',
  webviewButtonOpenAgainTitle: 'Opnieuw openen',
  notifications: {
    urlCopied: 'URL gekopieerd!'
  }
}
